export class Pattern {
  private static _values: Pattern[] = [];
  private static _lookup: Map<number, Pattern> = new Map();

  static fromId(id: number) {
    const instance = Pattern._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Pattern.id: ' + id);
    }
    return instance;
  }

  static values(): Pattern[] {
    return [...Pattern._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Pattern._values.push(this);
    Pattern._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Pattern: ' + this.id + ", label='" + this.label + "'>";
  }
}
